import { camelizeObject } from '@cvt/helpers/object';

export const mapDisciplineData = (data: Disciplines.DisciplineApi): Disciplines.Discipline => {
  const discipline = camelizeObject<Disciplines.Discipline>(data);
  return {
    ...discipline,
    match: {
      ...discipline.match,
      value: (discipline.match?.value || 0) / 100,
    },
  };
};
